<app-trip-analysis [tripResponse]="tripResponse" [isSectionDialog]="isSectionDialog" [tripSectionParameter]="tripSectionParameter"></app-trip-analysis>